import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

export const ReferalsContainer = styled("div")(
  ({ theme }) => css`
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 4rem;

    ${theme.breakpoints.up("mobile")} {
      padding: 8px 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      width: ${theme.breakpoints.values.tablet}px;
      padding: 0.5rem 55px;
    }

    ${theme.breakpoints.up("desktop")} {
      width: ${theme.breakpoints.values.desktop}px;
      padding: 2.5 55px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      width: ${theme.breakpoints.values.desktopXl}px;
      padding: 1.5rem 110px;
    }
  `,
);

export const ReferalContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
  `,
);

export const ReferalHeader = styled("h3")(
  ({ theme }) => css`
    ${cssForHeaderWithLinearGradient(
      theme,
      "linear-gradient(82.22deg, #05DF54 0%, #96C5F0 76%)",
    )}

    ${theme.palette.mode === "dark" &&
    css`
      text-shadow: 0px 0px 20px rgba(51, 235, 131, 0.25);
    `}

    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.heading_h3_bold_tablet)}
    }

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
    }

    margin-bottom: 0.5rem;
    text-align: center;
  `,
);

export const ReferalText = styled("span")(
  ({ theme }) => css`
    color: ${getColor(c => c.tokens.text["strong-950"], theme)};
    ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}

    margin-bottom: .5rem;
    max-width: 700px;
    text-align: center;
  `,
);

export const ReferalAuthor = styled("span")(
  ({ theme }) => css`
    ${cssForHeaderWithLinearGradient(
      theme,
      "linear-gradient(82.22deg, #05DF54 0%, #96C5F0 76%)",
    )}
    ${cssPropertiesToString(theme.typography.paragraph_medium_medium)};
    text-align: center;
  `,
);

export const ReferalCompany = styled("span")(
  ({ theme }) => css`
    color: ${getColor(c => c.tokens.text["sub-600"], theme)};
    ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    text-align: center;
  `,
);

export interface ButtonProps {
  flip?: boolean;
  disabled?: boolean;
}

export const ButtonStyled = styled("button")<ButtonProps>(
  ({ theme, flip, disabled }) => css`
    background: ${theme.mainContentGradient};
    border-radius: 100px;
    border-width: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    transform: ${flip ? "rotate(180deg)" : "none"};
    opacity: ${disabled ? 0.2 : 1};
    transition: opacity 0.3s;
    cursor: pointer;
  `,
);

export const ButtonWrapper = styled("div")(
  ({ theme }) => css`
    background: linear-gradient(82deg, #05df5414 0%, #96c5f014 76%);
    border-radius: 100px;
    padding: 6px;
  `,
);
